import { Controller, Menu } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { MENU_CONFIGS, config } from '@framework/workbench/ui/water-mark/config';
import { WaterMarkFeature } from '@framework/workbench/ui/water-mark/water-mark-feature';

/**
 * 水平对齐
 */
@Controller({
    menuItems: MENU_CONFIGS,
})
export class WaterMarkController {
    constructor(private readonly feature: WaterMarkFeature) {
    }

    @Menu(config.id, 'onClick')
    public showContent() {
        return this.feature.callback();
    }

    @Menu(config.id, 'shouldHide')
    public shouldHide() {
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.waterMark);
    }
}
